import { searchfilterStateId as sfState, tabs, terms } from '../../../constants/suggestedAgents';
import { modules } from '../../../../constants';
import { formatShortDate } from '../../../../common/helpers/date';
import { terms as  mdt } from '../../../../market-dynamics/constants';
import { validateRange } from '../../../../common/helpers/validation';

export const getCurrentTabTimePeriod = (producers, isGrowthAnalysisView) => producers?.newProd
    || (isGrowthAnalysisView ? producers?.growthTimeFrame : producers?.timeFrame)
    || producers?.timePeriod
    || null;

export const getTabFilters = (rowData, currentTabProducers) => ({
    topProducers: rowData.slice(0, parseInt(currentTabProducers?.lowPos?.label)),
});

export const getCurrentTabState = (currentModule, state) => {
    if (currentModule !== modules.proficiencyMetrics.suggestedAgents) return;
    const currentTabId = state[currentModule].currentTabId;
    const tabState = state[currentModule].searchOptions[currentTabId];
    return tabState;
};

export const getTabDescription = (currentTabId, args) => {
    const getTabDescription = tabs[currentTabId]?.description;
    return getTabDescription && tabs[currentTabId]?.description(args);
};

export const getFooterTimePeriodValue = (currentSearchDates, currentTabId) => {
    const getPreviousYearDate = (date) => {
        if (!date) return;
        return new Date(date)
        .setFullYear(new Date(date).getFullYear() - 1).toLocaleString();
    };
    const previousFromDate = getPreviousYearDate(currentSearchDates?.from);
    const previousToDate = getPreviousYearDate(currentSearchDates?.to);

    if (!currentSearchDates?.from || !currentSearchDates?.to) return '';
    if ([tabs.incProducers.id, tabs.decProducers.id].includes(currentTabId)) {
        return `${formatShortDate(currentSearchDates?.from)} - ${formatShortDate(currentSearchDates?.to)} vs.
            ${formatShortDate(new Date(Number(previousFromDate.replace(/,/g, ""))))} -
                ${formatShortDate(new Date(Number(previousToDate.replace(/,/g, ""))))}`;
    }
    return `${formatShortDate(currentSearchDates?.from)} - ${formatShortDate(currentSearchDates?.to)}`;
};

export const getFooterIncDecProducerValue = ({ minGrowth, maxGrowth, currentTabId, timeFrame, inactivityPeriod}) => {
    const incDecLabels = { [tabs.decProducers.id]: mdt.decrease.toLocaleLowerCase(), [tabs.incProducers.id]: mdt.increase.toLocaleLowerCase() };
    if (currentTabId === tabs.newProducers.id) return `${timeFrame}, ${inactivityPeriod} ${terms.inactivity}`;
    if (!minGrowth && !maxGrowth) return;
    if (!!minGrowth && !maxGrowth) return `>= ${minGrowth}% ${incDecLabels[currentTabId] || ''}`;
    if (!minGrowth && !!maxGrowth) return `<= ${maxGrowth}% ${incDecLabels[currentTabId] || ''}`;
    return `${minGrowth}% - ${maxGrowth}% ${incDecLabels[currentTabId] || ''}`;
};

export const toNegativeString = (positiveString) => {
    return '-' + positiveString;
};

export const getValidationSettings = ({ minGrowth, maxGrowth, currentTabId }) => {
    const termValidationByKeyField = { decProducers: 'decreasePct', incProducers: 'increasePct' };
    return validateRange(
        termValidationByKeyField[currentTabId],
        {
            min: parseInt(minGrowth),
            max: parseInt(maxGrowth)
        }
    );
};

export const getChangeWord = (isIncreasing) => isIncreasing ? terms.increase : terms.decrease;

export const getIncDecProducerTitle = (isIncreasingProducers, timePeriod, minGrowth = '', maxGrowth = '') => {
    let rangeText = '';

    if (minGrowth !== '' && maxGrowth !== '') {
        rangeText = terms.incDecBetween(minGrowth, maxGrowth);
    }

    if (minGrowth !== '' && maxGrowth === '') {
        rangeText = terms.incDecMinOnly(minGrowth);
    }

    if (minGrowth === '' && maxGrowth !== '') {
        rangeText = terms.incDecMaxOnly(maxGrowth);
    }

    return terms.incDecTitle(isIncreasingProducers, rangeText, timePeriod.toLowerCase());
};

export const getHasResults = (agentData) => (agentData?.results?.length > 0);

export const getOptionValue = (option, stateId) => {
    const isGrowthField = stateId === sfState.minGrowth || stateId === sfState.maxGrowth;
    if (isGrowthField) return option.replace(/\D/g, '');
    if (option?.value !== undefined) return option;
    if (option?.[stateId] !== undefined) return option[stateId];
    return option;
};

export const validateGrowthFields = (selectedTabState, currentTabId) => {
    const isIncOrDecProducersTab =
        currentTabId === tabs.incProducers.id || currentTabId === tabs.decProducers.id;
    const isMissingGrowth =
        !selectedTabState[currentTabId]?.minGrowth &&
        !selectedTabState[currentTabId]?.maxGrowth;
    return isIncOrDecProducersTab && isMissingGrowth;
};

export const resolveTabDescription = ({ selectedTabState, currentTabId, currentInactivityPeriod, currentTabTimePeriod, selectedLowPos }) => {
    if (currentTabId === tabs.topProducers.id) {
        const highProducingAgents =
            selectedTabState.topProducers?.lowPos?.label || selectedLowPos?.label;
        return getTabDescription(currentTabId, { highProducingAgents });
    }

    return getTabDescription(currentTabId, {
        inactivityPeriod: currentInactivityPeriod,
        timePeriod: currentTabTimePeriod?.label,
        minGrowth: selectedTabState?.[currentTabId]?.minGrowth,
        maxGrowth: selectedTabState?.[currentTabId]?.maxGrowth,
    });
};

export const getMlsToUpdate = ({ selectedTabState, currentTabId, mlsProviders }) => {
    const localMlsSelection = selectedTabState?.[currentTabId]?.mls;
    if (!localMlsSelection) return;
    return mlsProviders.find(mls => mls.mlsId === localMlsSelection?.value);
};
